import { render } from "./houseDetail.vue?vue&type=template&id=687695c5&scoped=true"
import script from "./houseDetail.vue?vue&type=script&lang=js"
export * from "./houseDetail.vue?vue&type=script&lang=js"

import "./houseDetail.vue?vue&type=style&index=0&id=687695c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687695c5"]])

export default __exports__